import React from 'react';
import styled from 'styled-components';

const Banner = ({ children }) => {
  return (
    <>
      {children}
    </>
  );
};

export default Banner;

const BannerContainer = styled.div`
  // align-items: center;
  // // background: ${({ theme }) => theme.fill.defaultSubtle};
  // background: ${({ theme }) => theme.fill.brandAlphaMain8};
  // // border: 1px solid ${({ theme }) => theme.border.defaultWeak};
  // border-radius: ${({ theme }) => theme.sizing.sm};
  // display: flex;
  // flex-direction: row;
  // gap: ${({ theme }) => theme.sizing.xs};
  // justify-content: space-between;
  // padding: ${({ theme }) => theme.sizing.sm};
  // width: 100%;
  // // box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.08);


  // @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
  //   flex-direction: column;
  //   row-gap: ${({ theme }) => theme.sizing.sm};
  //   border-radius: ${({ theme }) => theme.radius.xs};
  // }
`;